import { PlainDocument, preload } from '../../layouts/plain-document';
import type { RouteDefinition } from '@solidjs/router';

export default function TermsOfService() {
	return <PlainDocument slug="access-terms-and-conditions" />;
}

export const route = { preload: preload('access-terms-and-conditions') } satisfies RouteDefinition;
